import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import trophy from "../images/Trophy.svg";
import moneyBill from "../images/MoneyBill.svg";
import confetti from "../images/Confetti.svg";
import "../styles/UpdatedOneToOneSpif.css";

const SelectedOneToOneSpif = ({ iteration = 0, payout = "0"}) => {
    const [currentSvg, setCurrentSvg] = useState(null);
    const [confettiKey, setConfettiKey] = useState(0);
    const navigate = useNavigate();

    const routeToEarnings = () => {
        navigate("/earnings", { state: { editMode: true } });
    };

    useEffect(() => {
        if (iteration <= 1) {
            setCurrentSvg(moneyBill);
        } else {
            setCurrentSvg(trophy);
            setConfettiKey(prevKey => prevKey + 1);
        }
    }, [iteration]);

    return (
        <div className="selected-one-to-one-spif">
            {iteration <= 1 ? (
                <div>
                    {currentSvg && (
                        <img 
                            src={currentSvg}
                            alt="Money bill svg"
                            className="money-bill-svg"
                        />
                    )}
                    <div className="no-progress-text">
                        Sell GEICO, Earn Rewards
                    </div>
                </div>
            ) : (
                <div>
                    {currentSvg && (
                        <div>
                            <img 
                                src={currentSvg} 
                                alt="Trophy svg"
                                className="trophy-svg"
                            />
                            <img
                                src={confetti}
                                alt="Confetti svg"
                                className="confetti-svg"
                                key={confettiKey}
                            />
                        </div>
                    )}
                    <div className="yes-progress-text">
                        Congrats!
                    </div>
                    <div className="payout-background"> 
                        <div className="payout-text">
                            You earned 
                        </div>
                        <div className="payout-amount">
                            ${parseFloat(payout).toFixed(2)}
                        </div>
                        .
                    </div>
                </div>
            )}
            <div className="earnings-link-container">
                <button
                    onClick={routeToEarnings}
                    className="earnings-link"
                    type="text"
                    data-trackid="view-promotion-earnings">
                    View My Earnings
                </button>
            </div>
        </div>
    );
};

SelectedOneToOneSpif.propTypes = {
    iteration: PropTypes.number,
    payout: PropTypes.string
};

export default SelectedOneToOneSpif;